import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import { Heading } from '../../../sharedComponents';
import EmailOptInForm from '../../innerComponents/EmailOptInForm';
import { HeadingWrapper, Text } from '../../styles';
import { renderHTMLString } from '../../../../../../helpers';
import { ERROR, SUBSCRIBED } from '../../utils/constants';
import { EmailOptInPostMessage } from '../../innerComponents/EmailOptInPostMessage';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';

export const EmailOptInContent = (props) => {
  const {
    cookieName,
    headingText,
    descriptionText,
    buttonText,
    sapProductCode,
    confirmationMessage,
    subscriptionStatus,
    setSubscriptionStatus,
    userInterests,
    interestTitle,
    moduleType,
  } = props;

  const { location } = useRootSelector(selectPageConfig);
  const themeConfig = useContext(ThemeContext);
  const dStyles = themeConfig.module.dStyles;
  const vStyles = themeConfig.module.vStyles;

  const { xs, md, offset } = dStyles.contentGrid;

  const isSubmitted = subscriptionStatus === SUBSCRIBED;
  const isError = subscriptionStatus === ERROR;

  return isSubmitted || isError ? (
    <EmailOptInPostMessage
      confirmationMessage={confirmationMessage}
      subscriptionStatus={subscriptionStatus}
      isError={isError}
      data-testid="email-opt-in-post-message"
    />
  ) : (
    <div className="container" data-testid="email-opt-in-content-wrapper">
      <div className="row">
        <div className={`col-xs-${xs} col-md-${md} col-md-offset-${offset}`}>
          <div className="text-center">
            <HeadingWrapper displayStyles={dStyles} visualStyles={vStyles}>
              <Heading>{renderHTMLString(headingText, location)}</Heading>
            </HeadingWrapper>
            <Text visualStyles={vStyles} displayStyles={dStyles}>
              {renderHTMLString(descriptionText, location)}
            </Text>
          </div>
        </div>
      </div>
      <div className="row">
        <div className={`col-xs-${xs}`}>
          <EmailOptInForm
            headingText={headingText}
            cookieName={cookieName}
            sapProductCode={sapProductCode}
            buttonText={buttonText}
            setSubscriptionStatus={setSubscriptionStatus}
            userInterests={userInterests}
            interestTitle={interestTitle}
            moduleType={moduleType}
          />
        </div>
      </div>
    </div>
  );
};

EmailOptInContent.propTypes = {
  cookieName: PropTypes.string,
  headingText: PropTypes.oneOfType([PropTypes.string, () => null]),
  descriptionText: PropTypes.oneOfType([PropTypes.string, () => null]),
  buttonText: PropTypes.string,
  sapProductCode: PropTypes.string,
  confirmationMessage: PropTypes.string,
  subscriptionStatus: PropTypes.string,
  setSubscriptionStatus: PropTypes.func,
  interestTitle: PropTypes.string,
  moduleType: PropTypes.string,
  userInterests: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      interestTitle: PropTypes.string,
    }),
  ),
};
